<script setup>
import { useRoute } from "vue-router";
import { useCustomizerStore } from "@/stores/customizer";

const customizer = useCustomizerStore();
const route = useRoute();

const handleHover = (event) => {     
    customizer.inActiveChildBody = true
    console.log('child side . . .', customizer.activeChilds);
}

const mouseleaveHandler = () => {
    customizer.inActiveChildBody = false
    customizer.activeChilds = false
    customizer.parentHovered = ''
    if(customizer.mini_sidebar) {
        customizer.activeChilds = false;
        customizer.parentHovered = ''
    }
}

const navigate = (path) => {
    customizer.activeParent = customizer.parentHovered 
    navigateTo(path);
}

const darkTheme = computed(() => {
    const theme = customizer.actTheme
    if(theme.split('_')[0] == 'DARK') {
        return true
    } else {
        return false
    }
})
</script>    

<template>
    <div 
        class="custom-style rounded fade_animation_1"
        @mouseenter="handleHover" 
        @mouseleave="mouseleaveHandler"
        :class="{'dark-style': darkTheme , 'light-style': !darkTheme}"
        :style="{
            top: customizer.childernLocation.y+'px',
            right: customizer.childernLocation.x+'px'
        }"
    >
    <span class="custom-title">{{ $t(customizer.parentHovered) }}</span>
       <div 
        class="item-style cursor-pointer fade_animation_1 mt-2 py-2 px-2"
        v-for="item in customizer.selectedItem"
        @click="navigate(`${item.to}`)"
        :class="{'active-bg': route.path == item.to}"
        v-show="item?.permission"
        >
            <span>{{ $t(item.title) }}</span>
        </div>
    </div>
</template>

<style scoped>
.light-style {
    background: #00406B;
    color: #fff;
}
.dark-style {
    background-color: #00406B;
    color: #fff;
}

.custom-style{
    width: 200px;
    padding: 12px 12px;
    position: absolute;
    z-index: 5000;
    top: 30px;
    right: 20px;
    /* background-color: #fff; */
    /* dark */
    /* background-color: #212e41; */
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.068);
}

.item-style{
    font-size: 14px;
    font-weight: 400;
    color: #CACFD9;
}

.item-style:hover{
    background-color: rgba(var(--v-theme-secondary),20%);
    border-radius: 8px
}

.custom-title{
    font-size: 14px;
    font-weight: 600;
}

.active-bg {
  background-color: rgba(var(--v-theme-primary),20%);
  border-radius: 8px
}
</style>